<template>
  <div id="app">
    <Hub v-if="$store.state.page_type == 'hub'"></Hub>

    <Search v-else-if="$store.state.page_type == 'search'"></Search>
  </div>
</template>

<script>
import Hub from "./components/Hub.vue";
import Search from "./components/Search.vue";

export default {
  name: "App",
  components: {
    Hub,
    Search,
  },
};
</script>
